import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Antes tardaba horas en responder y no cerraba nada. Con los scripts del kit, cerré 3 ventas en la primera semana.',
  author: 'Lucía M.',
  role: 'Vende accesorios'
}, {
  quote: 'El follow-up era mi peor pesadilla. Ahora tengo mensajes listos y no siento que molesto.',
  author: 'Camila R.',
  role: 'Coach de nutrición'
}, {
  quote: 'Lo mejor es el Mapa 5F. Me dio estructura y dejé de improvisar cada conversación.',
  author: 'Valentina S.',
  role: 'Tienda de ropa'
}];
export function TestimonialsSection() {
  return <Section background="white" data-id="element-115">
      <div className="text-center mb-16" data-id="element-116">
        <h2 className="font-serif text-3xl md:text-4xl text-[#2D2D2D] mb-4" data-id="element-117">
          Emprendedoras que ya usan el Kit
        </h2>
        <div className="w-24 h-1 bg-[#C5A55A] mx-auto" data-id="element-118" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-119">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: index * 0.1
      }} className="bg-[#FDFBF7] p-8 rounded-xl shadow-sm border border-[#F5F0E8] flex flex-col" data-id="element-120">
            <div className="flex gap-1 mb-4 text-[#C5A55A]" data-id="element-121">
              {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-122" />)}
            </div>
            <p className="text-[#2D2D2D] italic mb-6 flex-grow leading-relaxed" data-id="element-123">
              "{t.quote}"
            </p>
            <div className="flex items-center gap-3" data-id="element-124">
              <div className="w-10 h-10 rounded-full bg-[#E8E0D5] flex items-center justify-center text-[#C5A55A] font-bold font-serif" data-id="element-125">
                {t.author[0]}
              </div>
              <div data-id="element-126">
                <p className="font-bold text-[#2D2D2D] text-sm" data-id="element-127">{t.author}</p>
                <p className="text-xs text-[#6B6B6B] uppercase tracking-wide" data-id="element-128">
                  {t.role}
                </p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </Section>;
}